import { useDOMRef, useStyleProps } from '@react-spectrum/utils'
import { DOMRef } from '@react-types/shared'
import { ModalProps } from '@react-types/overlays'
import React, { forwardRef } from 'react'
import { useOverlay } from '@react-aria/overlays'
import { ModalWrapper } from './ModalWrapper'
import { Overlay } from '../Overlay'
import { Underlay } from '../Underlay'

interface ModalPropTypes extends ModalProps {
  wrapperClassName?: string
  modalClassName?: string
}

function Modal(props: ModalPropTypes, ref: DOMRef<HTMLDivElement>) {
  const { children, onClose, type, ...otherProps } = props
  const domRef = useDOMRef(ref)
  const { styleProps } = useStyleProps(props)

  const { overlayProps, underlayProps } = useOverlay(props, domRef)

  return (
    // @ts-ignore
    <Overlay {...otherProps}>
      <Underlay {...underlayProps} />
      <ModalWrapper
        {...styleProps}
        onClose={onClose}
        type={type}
        ref={domRef}
        overlayProps={overlayProps}
        {...otherProps}
      >
        {children}
      </ModalWrapper>
    </Overlay>
  )
}

const _Modal = forwardRef(Modal)
export { _Modal as Modal }
